import { useEffect, ReactElement } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StateRedux } from './store/type-redux';
import NotFound404 from './pages/404';
import ForgotPassword from './pages/login/ForgotPassword';
import ChangePassword from './pages/login/ChangePassword';
import Login from './pages/login';
import Home from './pages/home';
import Usuarios from './pages/usuarios';
import Permissoes from './pages/permissoes';
import MiddlewareRoute from './components/MiddlewareRoute';

const Router = (): ReactElement => {
  const { i18n } = useTranslation();
  const {
    language: { languageSelected },
  } = useSelector((state: StateRedux) => state);

  useEffect(() => {
    i18n.changeLanguage(languageSelected, (err) => { if (err) console.log(err); });
  }, [languageSelected, i18n]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={(
            <MiddlewareRoute
              component={<Login />}
              publico
            />
          )}
        />

        <Route
          path="/forgot-password"
          element={(
            <MiddlewareRoute
              component={<ForgotPassword />}
              publico
            />
          )}
        />

        <Route
          path="/change-password/:token"
          element={(
            <MiddlewareRoute
              component={<ChangePassword />}
              publico
            />
          )}
        />

        <Route
          path="/"
          element={(
            <MiddlewareRoute
              component={<Login />}
              publico
            />
          )}
        />

        <Route
          path="/home"
          element={(
            <MiddlewareRoute
              component={<Home />}
              container
            />
          )}
        />

        <Route
          path="/usuarios"
          element={(
            <MiddlewareRoute
              component={<Usuarios />}
              container
            />
          )}
        />

        <Route
          path="/permissoes"
          element={(
            <MiddlewareRoute
              component={<Permissoes />}
              container
            />
          )}
        />

        <Route
          path="*"
          element={(
            <MiddlewareRoute
              component={<NotFound404 />}
              container
            />
          )}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
